import { Slide, ToastContainer } from "react-toastify";

export default function ToastWrapper({ children }) {
	return (
		<>
			{children}
			<ToastContainer
				theme="colored"
				position="top-center"
				autoClose={4500}
				closeOnClick={false}
				pauseOnHover={true}
				transition={Slide}
			/>
		</>
	);
}
